import { IonCol, IonContent, IonGrid, IonInput, IonPage, IonRow, IonText, IonIcon, IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory, useLocation } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import Select from 'react-select';
import service from "../../Service/service"
import Head from "../Header"
import Sidebar from "../Sidebar"
import swal from 'sweetalert'
import { searchOutline, chevronDownOutline } from "ionicons/icons";
import "../../theme/style2.css"
import { trashOutline } from 'ionicons/icons';

const Holiday: React.FC = () => {
    const history = useHistory();
    const location: any = useLocation();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    const [date, setdate] = useState("");
    const [description, setdescription] = useState('')
    const [holidayType,setholidayType]=useState("0")
    const [selectedYear, setSelectedYear] = useState('')
    const [modalopen, setmodalopen] = useState(false)
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {

        }
    }, [token, history]);
    const [data, setData]: any = useState([]);

    data.forEach((item: any, index: any) => { item.serial = index + 1; });

    const [filterText, setFilterText] = useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [business, setBusiness] = useState("");
    const [id, setId] = useState('');

    const [isEdit, setIsEdit] = useState(true);
    const [projectStatusId, setProjectStatusId] = useState("")
    const [loading, setloading] = useState(false)
    const [dataFetched, setDataFetched] = useState(false);


    //.................Years Autocomplete........................//

    const [selectedOption9, setSelectedOption9] = useState(null);
    const [inputValue9, setInputValue9] = useState('');
    const [isFocused9, setIsFocused9] = useState(false);
    const [menuIsOpen9, setMenuIsOpen9] = useState(false);

    const handleStateChange9 = (selectedOption9: any) => {
        setSelectedOption9(selectedOption9);
    };

    const handleInputChange9 = (inputValue9: any) => {
        setInputValue9(inputValue9);
    };

    const handleMenuOpen9 = () => {
        setMenuIsOpen9(true);
    };

    const handleMenuClose9 = () => {
        setMenuIsOpen9(false);
    };

    const handleFocus9 = () => {
        setIsFocused9(true);
    };

    const handleBlur9 = () => {
        setIsFocused9(false);
    };

    const Placeholder9 = () => {
        if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
            return <span style={{ color: "black" }}>Select Year</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen9) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen9]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const yearlist = (selectedOption9: any) => {
        setSelectedYear(selectedOption9.value);
    };



    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    

    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus= () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };

    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Type</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen9) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen9]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const list = (selectedOption: any) => {
        setholidayType(selectedOption.value);
    };





    const CreateLeave = () => {
        setmodalopen(true);
    }
    const closemodal = () => {

        setmodalopen(false);
        setdate('');
        setdescription('')
        setholidayType('')

    }

    // ----------------------Add Leave API ---------------------//
    const refreshLeaveData = () => {
    
        Leavelist();
        setmodalopen(false)
        setholidayType('')
        setdescription('');
        setdate('')
        
    };
    const Addleave = () => {
        service.Leaveadd(date, description,holidayType, token)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    swal({
                        title: "",
                        text: response.data.message,
                        icon: "success",
                    }).then((value) => {
                        if (value) {
                            refreshLeaveData();

                        }
                    });
                } else {
                    const errorMessage = response.data.message;
                    const dateRegex = /\d{4}-\d{2}-\d{2}/;
                    const dateMatch = errorMessage.match(dateRegex);

                    let formattedDate = "";
                    if (dateMatch) {
                        const originalDate = new Date(dateMatch[0]);
                        const day = originalDate.getDate().toString().padStart(2, '0');
                        const month = (originalDate.getMonth() + 1).toString().padStart(2, '0');
                        const year = originalDate.getFullYear();

                        formattedDate = `${day}-${month}-${year}`;
                    }

                    swal({
                        title: "Error",
                        text: `${errorMessage.replace(dateRegex, '')}${formattedDate}`,
                        icon: "error",
                    })
                }
            })


            .catch((error) => {
                console.error("Error:", error);
                swal({
                    title: "Error",
                    text: "An error occurred while processing your request",
                    icon: "error",
                });
            });
    };



    //*********************Yearwise leave list***********************/

    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 10 }, (_, index) => currentYear + index);

    const options = years.map((year) => ({
        label: year.toString(),
        value: year.toString(),
    }));

    const Type = [
        { value: '1', label: 'Infocareer' },
        { value: '2', label: 'Data-Annotation' },
    ]
    const Leavelist = () => {
        setloading(true);
        if (!selectedYear) {
            swal("",'Please select a year',"info");
            setloading(false);
            return;
        }

        service.Holiday(selectedYear,token,holidayType)
            .then((response) => {
                console.log(response);
                if (response.data.status === 200) {
                    setData(response.data.data);
                    setDataFetched(true); 


                } 
                    else if (response.data.status === 500) {
                      
                        swal("", response.data.message, "error")
                            .then(() => {
                      
                                setDataFetched(false);
                            });
                }
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setTimeout(() => {
                    setloading(false);
                }, 500);
            });
    }

    //----------------------Delete Api-------------------------//
    interface YourDataItemType {
        id: string; 
       
    }
    
    const Leavedelete = (id: string, status: boolean) => {
        if (!status) {
            swal({
                title: "Cannot Delete",
                text: "This record is inactive and cannot be deleted.",
                icon: "info",
            });
            return;
        }
    
        swal({
            title: "Are you sure?",
            text: "Once deleted, you will not be able to recover this record!",
            icon: "warning",
            buttons: ["Cancel", "Delete"],
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                service.DeleteLeave(id)
                    .then((response) => {
                        console.log(response);
                        if (response.data.status === 200) {
                            swal({
                                title: "",
                                text: response.data.message,
                                icon: "success",
                            }).then((value) => {
                                if (value) {
                                  
                                    setData((prevData:any) => prevData.filter((item: YourDataItemType) => item.id !== id));
                                }
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                        swal({
                            title: "Error",
                            text: "An error occurred while deleting the record",
                            icon: "error",
                        });
                    });
            }
        });
    };
    



    //--------------------Getall Leavelist Data table---------------------//

    const columns: any = [
        {
            name: "S.No",
            selector: (item: any, i: any) => item.serial,
            sortable: true,
            width: "83px",
        },
        {
            name: "Date",
            selector: (item: any) => item.date,
            cell: (item: any) => moment(item.date).format("DD-MM-YYYY"),
            sortable: true,


        },
        {
            name: "Description",
            selector: (item: any) => item.holidayDescription,
            sortable: true,

        },
        {
            name: 'Status',
            selector: (itm: any) => itm.status,
            sortable: true,
            cell: (itm: any) => (
                <div style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                    {itm.status === true ? (
                        <p style={{ color: "#00b700", margin: '0' }}>ACTIVE</p>
                    ) : (
                        <p style={{ color: "red", margin: '0' }}>INACTIVE</p>
                    )}
                </div>
            )
        },
        {
            name: 'Delete',
            sortable: false,
            cell: (item: any) => (
                <div>
                    <IonIcon
                        icon={trashOutline}
                        onClick={() => {
                            if (item.status) {
                                Leavedelete(item.id, item.status);
                            }
                        }}
 style={{
                            color: item.status ? 'red' : 'grey', 
                            cursor: item.status ? 'pointer' : 'not-allowed', 
                            fontSize: '20px',
                            marginLeft: '5px'
                        }}
                       
                    />
                </div>
            )
        }


    ];


    const customStyles = {
        headRow: {
            style: {
                width: "100%"
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px"
            },
        },
        cells: {
            style: {
                fontSize: "16px"
            }
        }
    };

    //----------------search filter---------------------//
    const tabledata = data.filter(
        (item: any) =>
            JSON.stringify(item)
                .toLowerCase()
                .indexOf(filterText.toLowerCase()) !== -1
    );

    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    //-----------------Getall Projects Api-----------------//

    const back = () => {
        history.goBack();
    }
    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Holiday List </h3>
                                </div>
                            </div>
                            <div className="col-auto float-end ml-auto">
                                <a onClick={CreateLeave} className="btn add-btn" data-bs-toggle="modal" ><i className="fa fa-plus" />Add Holidays</a>
                            </div>
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Years</label>
                                        <Select
                                            options={options}
                                            value={options.find((option: any) => option.value === selectedYear) || null}
                                            onChange={yearlist}
                                            onInputChange={handleInputChange9}
                                            onMenuOpen={handleMenuOpen9}
                                            onMenuClose={handleMenuClose9}
                                            onFocus={handleFocus9}
                                            onBlur={handleBlur9}
                                            menuIsOpen={menuIsOpen9}
                                            isSearchable

                                            placeholder={<Placeholder9 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator9,
                                            }}
                                            className="custom-select0"
                                        />
                                    </div>


                                </div>
                                <div className="col-sm-6 col-md-3">
                                <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Type</label>
                                        <Select
                                            options={Type}
                                            value={Type.find((option: any) => option.value === holidayType) || null}
                                            onChange={list}
                                            onInputChange={handleInputChange}
                                            onMenuOpen={handleMenuOpen}
                                            onMenuClose={handleMenuClose}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            menuIsOpen={menuIsOpen}
                                            isSearchable

                                            placeholder={<Placeholder />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator,
                                            }}
                                            className="custom-select0"
                                        />
                                    </div>
                               
</div>
                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        Leavelist()
                                    }} className="btn btn-orange btn-block w-100"> SEARCH </a>
                                </div>


                            </div>
                            {dataFetched && (
                            <div className="table-responsive" style={{ marginTop: "1%" }}>
                          
                    <DataTable
                        columns={columns}
                        data={tabledata}
                        pagination
                        paginationPerPage={10}
                        paginationComponentOptions={paginationComponentOptions}
                        subHeader
                        subHeaderComponent={subHeaderComponent}
                        customStyles={customStyles}
                    />
             
                            </div>
                               )}
                            <Modal
                                dialogClassName="modal-dialog modal-lg"
                              
                                show={modalopen}
                            >
                                <div className="modal-header">
                                    <h5 className="modal-title">Add Holiday </h5>
                                    <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close" onClick={() => closemodal()}>
                                        <span aria-hidden="true">×</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }} >Date <span className="text-danger" >*</span></label>
                                            <div>
                                                <IonInput value={date} onIonChange={(e: any) => setdate(e.detail.value)} type="date" className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label style={{ fontWeight: "bold" }}>Holiday Description <span className="text-danger">*</span></label>
                                            <div>
                                                <IonInput value={description} onIonChange={(e: any) => setdescription(e.detail.value)} className="form-control datetimepicker" />
                                            </div>
                                        </div>
                                      
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Type</label>
                                        <Select
                                            options={Type}
                                            value={Type.find((option: any) => option.value === holidayType) || null}
                                            onChange={list}
                                            onInputChange={handleInputChange}
                                            onMenuOpen={handleMenuOpen}
                                            onMenuClose={handleMenuClose}
                                            onFocus={handleFocus}
                                            onBlur={handleBlur}
                                            menuIsOpen={menuIsOpen}
                                            isSearchable

                                            placeholder={<Placeholder />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator,
                                            }}
                                            className="custom-select0"
                                        />
                                    </div>


                                
                                        <div className="submit-section">
                                            <button type="button" className="btn-primary submit-btn" onClick={Addleave}>Save</button>
                                        </div>
                                    </form>
                                </div>
                            </Modal>

                        </div>
                        {loading && (
                            <div
                                style={{
                                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 9999
                                }}
                            >
                                <div >
                                    <IonSpinner style={{
                                        width: "40px",
                                        height: "40px",
                                        color: "#ff8a53"
                                    }} name="lines" />
                                </div>
                            </div>
                        )}

                    </div>

                </div>


            </IonContent>
        </IonPage>
    )
}

export default Holiday
